<template>
  <div
    v-if="permissionInfo.is_show_comments"
    class="comment-module"
  >
    <ul
      v-if="comment.list && comment.list.length"
      class="list-box"
    >
      <li
        v-for="(item, index) in comment.list"
        :key="item.id"
      >
        <div class="top clearfix">
          <span class="time">{{ moment(item.addtime * 1000).format('YYYY-MM-DD HH:mm:ss') }}</span>
          <span class="name">{{ item.truename }}</span>
          <a
            v-if="permissionInfo.is_del_comments"
            class="del-btn fs-blue fr"
            @click="handleDeleteComment(item.id)"
          >{{ $t('message["962"]') }}</a>
        </div>
        <div class="content">
          {{ item.content }}
        </div>
        <!-- 评论操作按钮 -->
        <div
          v-if="permissionInfo.is_add_comments"
          class="operate-btns"
        >
          <span
            class="mesage"
            @click="toggleReply(item, index)"
          >
            <i class="iconfont iconpinglun" />{{ (item.replys && item.replys.length) || $t('message["449"]') }}
          </span>
        </div>
        <!-- 评论回复列表 -->
        <div
          class="replys-list"
          :class="{show: item.showReply}"
        >
          <div
            v-if="permissionInfo.is_add_comments"
            class="add-box clearfix"
          >
            <div
              class="input-wrap clearfix"
              :class="{ 'fold-input': item.fold }"
            >
              <span
                :ref="`truename${item.showReply? 'Show' : ''}`"
                class="truename"
              >@{{ item.truename }}:</span>
              <a-input
                v-model="item.newReply"
                type="textarea"
                :style="{'padding-left': item.trueNameWidth + 'px'}"
                @focus="handleFocusReply($event, item)"
              />
            </div>
            <a-button
              v-if="!item.fold"
              type="primary"
              :disabled="item.newReply === '' || item.newReply === undefined"
              @click="handleNewReply(item)"
            >
              {{ $t('message["449"]') }}
            </a-button>
          </div>
          <ul v-if="item.replys">
            <li
              v-for="reply in item.replys"
              :id="`reply_${reply.id}`"
              :key="reply.id"
            >
              <div
                class="reply-top clearfix"
              >
                {{ moment(reply.addtime * 1000).format(dateFormat) }} {{ reply.truename }}
                <a
                  v-if="permissionInfo.is_del_comments"
                  class="del-btn fs-blue fr"
                  @click="handleDeleteReply(reply.id, item.id)"
                >{{ $t('message["962"]') }}</a>
              </div>
              <div class="reply-content">
                @{{ reply.rtruename }}:{{ reply.content }}
              </div>
              <div class="operate-btns">
                <add-reply-popover
                  :data="{ commentid: item.id, replyid: reply.id, replytype: 2 , truename: reply.truename }"
                  @submit="addReply"
                />
              </div>
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <div
      v-else
      class="fs-gray"
    >
      {{ $t('message["1552"]') }}
    </div>
    <add-comment-modal
      :visible.sync="showCommentModal"
      :inquiry-id="inquiryId"
    />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import moment from 'moment'
import AddCommentModal from './modal/AddComment'
import AddReplyPopover from './modal/AddReplyPopover'
import { inquiryCommentReply } from '@/services/inqueryServices'

export default {
  components: {
    AddCommentModal,
    AddReplyPopover
  },
  data () {
    return {
      dateFormat: 'YYYY-MM-DD HH:mm',
      showCommentModal: false
    }
  },
  computed: {
    ...mapState('inquery/detailData', ['comment']),
    ...mapGetters('inquery/detailData', ['permissionInfo']),
    inquiryId () {
      return this.$route.params.inquiryId
    },
    commentid () {
      return this.$route.query.commentid
    },
    replyid () {
      return this.$route.query.replyid
    }
  },
  async created () {
    await this.getCommentList()

    this.$bus.$on('getCommentList', this.getCommentList)
  },
  beforeDestroy () {
    this.$bus.$off('getCommentList')
  },
  methods: {
    moment,
    ...mapActions('inquery/detailData', [
      'fetchCommentList',
      'inquiryDelComment',
      'inquiryDelCommentReply'
    ]),
    addComment () {
      this.showCommentModal = true
    },
    async getCommentList (newCommentid) {
      const chain = await this.fetchCommentList()
      chain
        .params({
          inquiryid: this.inquiryId
        })
        .onSuccess(res => {
          let commentid = newCommentid || this.commentid
          if (this.comment.list && this.comment.list.length) {
            for (let index in this.comment.list) {
              let item = this.comment.list[index]
              if (parseInt(item.id) === parseInt(commentid)) {
                this.setShowReplyTrueNameWidth(item, index)
              }
              if (item.replys && item.replys.length) {
                this.$set(item, 'fold', true)
              }
            }
            let id = 'reply_' + this.replyid
            let $currReply = document.getElementById(id)
            setTimeout(() => {
              $currReply && $currReply.scrollIntoView(false)
            }, 30)
          }
        })
        .fetch()
    },
    toggleReply (item, index) {
      if (!item.showReply) {
        this.setShowReplyTrueNameWidth(item, index)
      } else {
        this.$set(item, 'showReply', false)
        if (item.replys && item.replys.length) {
          this.$set(item, 'fold', true)
        }
      }
    },
    setShowReplyTrueNameWidth (item, index) {
      if (this.permissionInfo.is_add_comments) {
        this.$set(item, 'showReply', true)
      }

      setTimeout(() => {
        let $truename = this.$refs.truenameShow
        let trueNameWidth = $truename && $truename[0] && $truename[0].offsetWidth
        this.$set(item, 'trueNameWidth', trueNameWidth + 8)
      }, 30)
    },
    handleFocusReply (e, item) {
      this.$set(item, 'fold', false)
    },
    handleNewReply (item) {
      const obj = {
        commentid: item.id,
        replytype: 1,
        content: item.newReply || ''
      }
      this.addReply(obj, item)
      item.newReply = ''
    },
    async addReply ({ commentid, replyid, replytype, content }) {
      let params = {
        inquiryid: this.inquiryId,
        commentid,
        replytype, // 1回复回访记录 2回复回访记录评论
        content
      }
      if (replytype === 2) {
        params.replyid = replyid
      }
      let chain = await inquiryCommentReply()
      chain
        .params(params)
        .onNetSuccess(res => {
          this.getCommentList(commentid)
        })
        .fetch()
    },
    handleDeleteComment (commentid) {
      let delTextArr = this.$t('message["1888"]').split('|')
      let content = <div><span class="fs-orange">{ delTextArr[0] }</span>{ delTextArr[1] }</div>
      this.$confirm({
        title: this.$t('message["1890"]'), // '将删除该条评论及回复'
        content,
        closable: true,
        okText: this.$t('message["962"]'), // '删除'
        okType: 'danger',
        cancelText: this.$t('message["896"]'), // '取消'
        class: 'confirm-warn-modal',
        onOk: async () => {
          const chain = await this.inquiryDelComment({ inquiryid: this.inquiryId, commentid: commentid })
          chain
            .onSuccess(res => {
              this.getCommentList()
            })
        }
      })
    },
    handleDeleteReply (replyid, commentid) {
      let delTextArr = this.$t('message["1888"]').split('|')
      let content = <div><span class="fs-orange">{ delTextArr[0] }</span>{ delTextArr[1] }</div>
      this.$confirm({
        title: this.$t('message["1889"]'), // '将删除该条回复'
        content,
        closable: true,
        okText: this.$t('message["962"]'), // '删除'
        okType: 'danger',
        cancelText: this.$t('message["896"]'), // '取消'
        class: 'confirm-warn-modal',
        onOk: async () => {
          const chain = await this.inquiryDelCommentReply({ inquiryid: this.inquiryId, id: replyid })
          chain
            .onSuccess(res => {
              this.getCommentList(commentid)
            })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.comment-module {
  padding: 24px 0;

  .list-box {
    & > li {
      padding: 12px 0 24px;
      line-height: 1;
      border-top: solid 1px $gray4;
      &:first-child {
        border: none;
      }
    }
    .name {
      margin: 0 8px;
    }
    .content {
      margin-top: 18px;
      line-height: 24px;
      color: $gray2;
      word-break: break-all;
    }
    .operate-btns {
      height: 32px;
      line-height: 32px;
      margin-top: 12px;
      text-align: right;
      color: #d6d6d6;
      .iconfont {
        margin-right: 5px;
      }
      .mesage {
        cursor: pointer;
      }
    }
    .replys-list {
      display: none;
      padding: 16px;
      background-color: #f5f5f5;
      &.show {
        display: block;
      }
      li {
        padding: 2px 0 16px;
        line-height: 1;
        border-top: solid 1px $gray4;
      }
      .reply-top {
        margin-bottom: 12px;
        line-height: 24px;
        color: #333;
      }
      .reply-content {
        color: #666;
        line-height: 24px;
        word-break: break-all;
      }
    }
    .add-box {
      margin-bottom: 24px;
      .input-wrap {
        position: relative;
        // width: 274px;
        height: 72px;
        border: 1px solid #5077aa;
        border-radius: 2px;
        &.fold-input {
          height: 40px;
          border-color: #d6d6d6;
        }
        .truename {
          position: absolute;
          top: 12px;
          left: 8px;
          z-index: 2;
          color: #999;
        }
        .ant-input {
          width: 100%;
          height: 100%;
          padding: 8px;
          border-radius: 2px;
          border: none;
          resize: none;
        }
      }
      .ant-btn {
        float: right;
        width: 56px;
        height: 32px;
        margin-top: 8px;
        &.ant-btn[disabled] {
          color: #fff;
          background: linear-gradient(
            360deg,
            rgba(80, 119, 170, 1) 0%,
            rgba(96, 143, 204, 1) 100%
          );
          box-shadow: 0px 1px 1px 0px rgba(255, 255, 255, 0.5);
          border: 1px solid rgba(80, 119, 170, 1);
          opacity: 0.8;
        }
      }
    }
  }
}
</style>
